<template>
  <van-popup class="popup-box" v-model="visible" position="bottom">
    <div class="popup">
      <div class="header">退款原因</div>
      <div class="main">
        <div class="list">
          <div
            class="item"
            v-for="(item, index) of reason.list"
            :key="item.id"
            @click="onItemClick(index)"
          >
            <div class="check">
              <img
                class="image"
                :src="reason.index === index ? icons.checked : icons.uncheck"
                alt=""
              />
            </div>
            <div class="view">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="btn" @click="onConfirmClick">确定</div>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      icons: {
        uncheck:
          'https://img.chinabeego.com/uploadfile/2022/11/9/16679768816178482130367628120.png',
        checked:
          'https://img.chinabeego.com/uploadfile/2022/11/9/16679768672988482116048591615.png'
      },
      reason: {
        index: -1,
        list: [
          {
            id: 'COUPON_DONT_WANT',
            name: '不想要了',
            checked: false
          },
          {
            id: 'COUPON_BUY_ERROR',
            name: '买错了/买多了',
            checked: false
          },
          {
            id: 'COUPON_EXPIRE',
            name: '券已过期，无法使用',
            checked: false
          },
          {
            id: 'COUPON_OTHER',
            name: '其他',
            checked: false
          }
        ]
      }
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
    hide() {
      this.visible = false;
    },
    onItemClick(index) {
      this.reason.index = index;
    },
    onConfirmClick() {
      if (this.reason.index === -1) {
        return this.$toast('请选择退款原因');
      }
      const { list, index } = this.reason;
      this.$emit('confirm', list[index]);
      this.hide();
    }
  }
};
</script>

<style lang="less" scoped>
.popup-box {
  background-color: transparent;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #3b3a38;
}
.popup {
  height: 46vh;
  border-radius: 20px 20px 0px 0px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
}
.header {
  height: 112px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  font-family: PingFangSC-Medium, PingFang SC;
  font-size: 32px;
  font-weight: 500;
  color: #333333;
}
.main {
  flex: 1;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 0 36px;
  .item {
    display: flex;
    align-items: center;
    margin-bottom: 38px;
  }
  .check {
    flex-shrink: 0;
    width: 64px;
    display: flex;
    align-items: center;
  }
  .check .image {
    display: block;
    width: 48px;
    height: 48px;
  }
  .view {
    flex: 1;
  }
  .textarea {
    margin-top: 16px;
    width: 100%;
    display: block;
    resize: none;
    border: 0;
    outline: 0;
    height: 154px;
    background-color: #f6f6f6;
    border-radius: 8px;
    padding: 24px;
    box-sizing: border-box;
  }
}

.footer {
  height: 112px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  .btn {
    flex: 1;
    font-family: PingFangSC-Medium, PingFang SC;
    font-size: 28px;
    font-weight: 500;
    height: 80px;
    border-radius: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffd102;
  }
}
</style>
